import { configureStore } from "@reduxjs/toolkit";
// Or from '@reduxjs/toolkit/query/react'
import { setupListeners } from "@reduxjs/toolkit/query";
import { coinApi, newsApi } from "./api.js";
import { themeSlice } from "./themeSlice.js";

export const store = configureStore({
  reducer: {
    // Add the generated reducer as a specific top-level slice
    [coinApi.reducerPath]: coinApi.reducer,
    [newsApi.reducerPath]: newsApi.reducer,
    mode: themeSlice.reducer,
  },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(coinApi.middleware)
      .concat(newsApi.middleware),
});

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);
